<!-- 標題 & 麵包屑 -->
<div class="row header" #pageHeader>
  <div class="bs-slider-overlay"></div>
  <div class="col-lg-10 col-lg-offset-1 col-md-12">
    <ol class="breadcrumb">
      <li><a [routerLink]="toHomePath">{{'home' | translate}}</a> </li>
      <li class="active">{{'searchpage.title' | translate}}</li>
    </ol>
    <h2 class="page-header-b sr-only sr-only-focusable">{{'searchpage.title' | translate}}</h2>
  </div>
</div>
<!-- /.標題 & 麵包屑 -->

<!-- 區塊:1 -->
<app-data-search-form
[isUseLog]="true"
(beforeLoadData)="onBeforeLoadData()"
(dataLoaded)="onDataLoaded()"
(formReset)="onFormReset()"
#searchForm>
  <div class="sticky_search" [class.invisible]="!showStickySearchBtn" #stickyToggler>
    <a href="javascript:void(0)" role="button" title="{{'searchpage.toggleStickySearchBar' | translate}}" attr.aria-disabled="{{!showStickySearchBtn}}"
    (click)="stickSearchForm('#top_function', stickyToggler)">
      <i class="fa fa-search" aria-hidden="true" style="padding: 8px 0 0 12px;color: #f4bf01;"></i>
      <span class="sr-only">{{'searchpage.toggleStickySearchBar' | translate}}</span>
    </a>
  </div>

  <!-- 區塊:2 -->
  <section class="row clearfix p-h-md">
    <div class="col-lg-12 col-md-12">
      <div class="search_03" *ngIf="searchForm && searchForm.searchResult && searchForm.searchResult.length">
        <div class="row m-n">
          <div class="event-tab">
            <ul class="nav nav-pills" role="tablist">
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="resultView1Tab" [class.active]="viewMode === 1"
                 href="#resultView1" role="tab"
                aria-controls="result-view1" attr.aria-selected="{{viewMode === 1 ? 'true' : 'false'}}"
                (click)="toggleViewMode($event)"><span class="liststyle001">{{'searchpage.pictureMode' | translate}}</span></a>
              </li>
              <li class="nav-item" role="presentation">
                <a class="nav-link" id="resultView2Tab" [class.active]="viewMode === 2"
                href="#resultView2" role="tab"
                aria-controls="result-view1" attr.aria-selected="{{viewMode === 2 ? 'true' : 'false'}}"
                (click)="toggleViewMode($event)"><span class="liststyle002">{{'searchpage.graphicMode' | translate}}</span></a>
              </li>
            </ul>
          </div>
        </div>

        <div class="tab-content" id="resultViewTabContent">
          <div id="resultView1" class="tab-pane fade row m-n" role="tabpanel" aria-labelledby="resultView1Tab"
          [class.show]="viewMode === 1 && !isViewModeAnimating" [class.active]="viewMode === 1">
            <ng-container *ngIf="viewMode === 1">
              <div class="search-list_tab1">
                <ul
                infiniteScroll
                [infiniteScrollDistance]="3"
                [fromRoot]="true"
                (scrolled)="onScrollResult()">
                  <ng-container *ngFor="let item of cPagingSearchResult; index as cIndex">
                    <li class="tab1_picframe" [class.voice-material]="item['format'] === '聲音'" [class.small-img]="item['imageNaturalHeight'] && item['imageNaturalHeight'] < 200">
                      <a routerLink="{{toHomePath}}/detail" [queryParams]="{indexCode: item.fetchIndex, id: item.materialId, recOffset: (searchForm.offset + cIndex), searchWithKeywordTimeStamp: (searchForm.searchWithKeywordTimeStamp || '')}" queryParamsHandling="merge"
                      title="{{'readMore2' | translate}}{{item['materialName']}}" (click)="toDetailPage($event, item, cIndex)"
                      appLogHitCount [logLock]="lock" appLock #lock="lock">
                        <div class="tab1_imgholder" #containerRef>
                          <div class="small-img-background" [style.background-image]="item['imageNaturalHeight'] && item['imageNaturalHeight'] < 200 ? ('url(' + apiHost + '/api/collection/image/' + item.fetchIndex + '?uid=' + item.materialId + ')') : ''"></div>
                          <ng-container *ngIf="item.iframeUrl; else elseTemplateImgViewMode1">
                            <ng-container *ngIf="item['format'] === '聲音'; else videoTmp">
                              <!-- <video width="auto" height="200" muted="true" loop="" (load)="item['videoReady'] = true;" *ngIf="!isTouchScreen"
                              title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}">
                                <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/mp4">
                                <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/ogg">
                              </video>
                              <video width="auto" height="200" muted="true" loop="" (load)="item['videoReady'] = true;" playsinline="" *ngIf="isTouchScreen"
                              title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}">
                                <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/mp4">
                                <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/ogg">
                              </video> -->
                              <img src="/assets/images/audio_cover.webp" class="voice-background-image" alt="聲音素材"
                              width="355" height="200" tmObjectFit="contain" imgSrc="/assets/images/audio-cover.webp"
                              [lazyLoading]="coffset > 0">
                              <!-- <div class="overlay"></div> -->
                              <!-- <img src="/assets/images/img/arrow.svg" class="voice-operator"
                              width="50" height="50" tmObjectFit="contain"
                              [lazyLoading]="coffset > 0"> -->
                            </ng-container>
                            <ng-template #videoTmp>
                              <ng-container *ngIf="item.iframeUrl.endsWith('.m3u8'); else commonVideoTmp">
                                <iframe
                                title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                                [src]="$any(('/assets/hls-video-player?url=' + (item.iframeUrl | base64) + '&width=' + containerRef.offsetWidth + '&height=' + containerRef.offsetHeight) | safe: 'resource')"
                                [width]="containerRef.offsetWidth" [height]="containerRef.offsetHeight"
                                frameborder="0" allowfullscreen scrolling="no"
                                ></iframe>
                              </ng-container>
                              <ng-template #commonVideoTmp>
                                <iframe
                                [src]="$any(item.iframeUrl | safe: 'resource')" title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                                width="355" height="200" frameborder="0" allowfullscreen scrolling="no"
                                ></iframe>
                              </ng-template>
                            </ng-template>
                          </ng-container>
                          <ng-template #elseTemplateImgViewMode1>
                            <img src="{{apiHost}}/api/collection/image/{{item.fetchIndex}}?uid={{item.materialId}}" alt=""
                            [style.width]="imgRef && imgRef.naturalHeight < 200 ? (imgRef.naturalWidth + 'px') : ''"
                            width="{{imgRef && imgRef.naturalWidth || '200'}}" height="200"
                            [tmObjectFit]="!imgRef || imgRef && imgRef.naturalHeight >= 200 ? 'cover' : 'scale-down'" imgSrc="{{apiHost}}/api/collection/image/{{item.fetchIndex}}?uid={{item.materialId}}"
                            [tmErrorDefaultImage]="item['defaultImageUrl']"
                            [lazyLoading]="coffset > 0"
                            (load)="onMaterialImageSrcLoad(item, imgRef)"
                            #imgRef>
                          </ng-template>
                        </div>
                        <div class="box">
                          <p class="ellipsis">{{item['materialName']}}</p>
                        </div>
                      </a>
                      <div class="t-mark-t15">
                        <theme-collect-btn type="collection" [materialId]="item.materialId" [fetchIndex]="item.fetchIndex" [title]="item.materialName"></theme-collect-btn>
                      </div>
                    </li>
                  </ng-container>
                </ul>

                <div class="loading-bar" *ngIf="cPagingSearchResult.length !== ctotal">
                  <tm-loading [show]="true" [config]="{ backdropBorderRadius: '3px' }"></tm-loading>
                </div>
              </div>
            </ng-container>
          </div>

          <div id="resultView2" class="tab-pane fade row m-n" role="tabpanel" aria-labelledby="resultView2Tab"
          [class.show]="viewMode === 2 && !isViewModeAnimating" [class.active]="viewMode === 2">
            <ng-container *ngIf="viewMode === 2">
              <div class="row"
              infiniteScroll
              [infiniteScrollDistance]="3"
              [fromRoot]="true"
              (scrolled)="onScrollResult()">
                <ng-container *ngFor="let item of cPagingSearchResult; index as cIndex">
                  <div class="col-12 col-sm-12 col-md-6 search-detail p-h-xs">
                    <a routerLink="{{toHomePath}}/detail" [queryParams]="{indexCode: item.fetchIndex, id: item.materialId, recOffset: (searchForm.offset + cIndex)}" queryParamsHandling="merge"
                    title="{{'readMore2' | translate}}{{item['materialName']}}" (click)="toDetailPage($event, item, cIndex)"
                    appLogHitCount [logLock]="lock" appLock #lock="lock">
                      <div class="clearfix">
                        <div class="col-12 col-md-6">
                          <div class="image-wrap tab2_picframe"
                          [class.tab2_videoframe]="item['format'] === '影片'"
                          [class.voice-material]="item['format'] === '聲音'"
                          [class.small-img]="item['imageNaturalHeight'] && item['imageNaturalHeight'] < 200">
                            <div class="small-img-background" [style.background-image]="item['imageNaturalHeight'] && item['imageNaturalHeight'] < 200 ? ('url(' + apiHost + '/api/collection/image/' + item.fetchIndex + '?uid=' + item.materialId + ')') : ''"></div>
                            <ng-container *ngIf="item.iframeUrl; else elseTemplateImgViewMode2">
                              <ng-container *ngIf="item['format'] === '聲音'; else videoTmp">
                                <!-- <video width="355" height="200" muted="true" loop="" (load)="item['videoReady'] = true;" *ngIf="!isTouchScreen"
                                title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}">
                                  <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/mp4">
                                  <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/ogg">
                                </video>
                                <video width="355" height="200" muted="true" loop="" (load)="item['videoReady'] = true;" playsinline="" *ngIf="isTouchScreen"
                                title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}">
                                  <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/mp4">
                                  <source [src]="$any(item.iframeUrl | safe: 'resource')" type="video/ogg">
                                </video> -->
                                <img src="/assets/images/audio_cover.webp" class="voice-background-image" alt="聲音素材"
                                width="355" height="200" tmObjectFit="contain" imgSrc="/assets/images/audio-cover.webp"
                                [lazyLoading]="coffset > 0">
                                <!-- <div class="overlay"></div> -->
                                <!-- <img src="/assets/images/img/arrow.svg" class="voice-operator"
                                width="50" height="50" tmObjectFit="contain"
                                [lazyLoading]="coffset > 0"/> -->
                              </ng-container>
                              <ng-template #videoTmp>
                                <div class="embed-responsive embed-responsive-16by9">
                                  <div class="embed-responsive-item" #containerRef>
                                    <ng-container *ngIf="item.iframeUrl.endsWith('.m3u8'); else commonVideoTmp">
                                      <iframe
                                      title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                                      [src]="$any(('/assets/hls-video-player?url=' + (item.iframeUrl | base64) + '&width=' + containerRef.offsetWidth + '&height=' + containerRef.offsetHeight) | safe: 'resource')"
                                      [width]="containerRef.offsetWidth" [height]="containerRef.offsetHeight"
                                      frameborder="0" allowfullscreen scrolling="no"
                                      ></iframe>
                                    </ng-container>
                                    <ng-template #commonVideoTmp>
                                      <iframe
                                      [src]="$any(item.iframeUrl | safe: 'resource')" title="{{item.materialName}}{{'detailPage.fieldLabel.iframeUrl' | translate}}"
                                      width="355" height="200" frameborder="0" allowfullscreen scrolling="no"
                                      ></iframe>
                                    </ng-template>
                                  </div>
                                </div>
                              </ng-template>
                            </ng-container>
                            <ng-template #elseTemplateImgViewMode2>
                              <img  src="{{apiHost}}/api/collection/image/{{item.fetchIndex}}?uid={{item.materialId}}" alt=""
                              width="{{item['imageNaturalWidth'] || '200'}}" height="200"
                              [tmObjectFit]="!item['imageNaturalHeight'] || item['imageNaturalHeight'] && item['imageNaturalHeight'] >= 200 ? 'cover' : 'scale-down'" imgSrc="{{apiHost}}/api/collection/image/{{item.fetchIndex}}?uid={{item.materialId}}"
                              [tmErrorDefaultImage]="item['defaultImageUrl']"
                              [lazyLoading]="coffset > 0"
                              (load)="onMaterialImageSrcLoad(item, imgRef2)"
                              #imgRef2>
                            </ng-template>
                          </div>
                        </div>
                        <div class="col-12 col-md-6">
                          <!-- 標題和內文 -->
                          <div class="row info">
                            <h3 class="title text-overflow">{{item['materialName']}}</h3>
                            <p class="desc text-ellipsis multiline" tmTextEllipsis="multi" *ngIf="!isViewModeAnimating" [innerHTML]="item['description'] | safe: 'html'"></p>
                          </div>
                        </div>
                      </div>
                    </a>
                    <div class="t-mark-h15">
                      <theme-collect-btn type="collection" [materialId]="item.materialId" [fetchIndex]="item.fetchIndex" [title]="item.materialName"></theme-collect-btn>
                    </div>
                  </div>
                </ng-container>
              </div>

              <div class="loading-bar" *ngIf="cPagingSearchResult.length !== ctotal">
                <tm-loading [show]="true" [config]="{ backdropBorderRadius: '3px' }"></tm-loading>
              </div>
            </ng-container>
          </div>
        </div>
      </div>

      <div class="search_03" *ngIf="searchForm && searchForm.searchResult && !searchForm.searchResult.length">
        <p class="text-center">{{'noData' | translate}}</p>
      </div>
    </div>
  </section>
</app-data-search-form>
<!-- /.區塊:1 -->
